import { useState } from "react";
import { getApiUrl } from "../../config/api";

type Status = "Active" | "Inactive" | "Deleted";

/**
 * Generic hook for PATCH status updates (category or subcategory).
 * Returns updateStatus, delete, toggleStatus, and loading state.
 */
export function useStatusUpdate(apiPath: string) {
  const [apiLoading, setApiLoading] = useState<string>("");

  const updateStatus = async (
    id: string,
    status: Status
  ): Promise<boolean> => {
    try {
      setApiLoading(id);
      const response = await fetch(
        getApiUrl(`${apiPath.replace(/\/$/, "")}/${id}?status=${status}`),
        {
          method: "PATCH",
          headers: { accept: "application/json" },
        }
      );

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(
          errorData.message || `HTTP error! status: ${response.status}`
        );
      }

      await response.json();
      return true;
    } catch (error) {
      console.error(`Error updating status to ${status}:`, error);
      alert(
        error instanceof Error
          ? `Error: ${error.message}`
          : `Failed to ${status.toLowerCase()}. Please try again.`
      );
      return false;
    } finally {
      setApiLoading("");
    }
  };

  return { updateStatus, apiLoading };
}
